export const LOGIN = 'LOGIN'
export const PROFIL = 'PROFIL'
export const LOGOUT = 'LOGOUT'